import React from 'react';
import { Proposal, ProposalStatus } from '../api/proposalApi';
import { Eye, Send } from 'lucide-react';
import ProposalStatusBadge from './ProposalStatusBadge';
import Spinner from './Spinner';

interface Props {
  proposals: Proposal[];
  loading: boolean;
  onSend: (id: string) => void;
  onView: (id: string) => void;
}

export default function ProposalsList({ proposals, loading, onSend, onView }: Props) {
  return (
    <div className="bg-white rounded-[2rem] border border-slate-200 overflow-hidden shadow-sm">
        {loading ? (
          <div className="p-12 flex flex-col items-center justify-center"><Spinner /></div>
        ) : (
          <div className="overflow-x-auto border-t border-slate-200">
            <table className="w-full text-left border-collapse">
              <thead>
                <tr className="bg-slate-100 border-b border-slate-200 text-xs font-bold text-slate-500 uppercase tracking-wider">
                  <th className="px-6 py-4 border-r border-slate-200">Title</th>
                  <th className="px-6 py-4 border-r border-slate-200">Customer</th>
                  <th className="px-6 py-4 border-r border-slate-200 text-center">Status</th>
                  <th className="px-6 py-4 border-r border-slate-200">Expiry Date</th>
                  <th className="px-6 py-4 text-right">Actions</th>
                </tr>
              </thead>
              <tbody className="font-medium">
                {proposals.map((p) => (
                  <tr key={p.id} className="hover:bg-slate-50/50 transition-colors group">
                    <td className="px-6 py-4 text-slate-900 border-r border-b border-slate-100">{p.title}</td>
                    <td className="px-6 py-4 border-r border-b border-slate-100">
                      <div className="text-sm text-slate-700">{p.customerName}</div>
                      <div className="text-[10px] text-slate-400 font-bold uppercase tracking-tighter">{p.customerEmail}</div>
                    </td>
                    <td className="px-6 py-4 text-center border-r border-b border-slate-100"><ProposalStatusBadge status={p.status} /></td>
                    <td className="px-6 py-4 text-sm text-slate-500 border-r border-b border-slate-100">
                      {p.expiryDate ? new Date(p.expiryDate).toLocaleDateString() : '—'}
                    </td>
                    <td className="px-6 py-4 border-b border-slate-100">
                      <div className="flex justify-end gap-2">
                        <button onClick={() => onView(p.id)} className="p-2 bg-slate-50 text-slate-500 rounded-lg hover:text-blue-600 border border-transparent hover:border-slate-200 transition-all">
                          <Eye size={18} />
                        </button>
                        {p.status === ProposalStatus.Draft && (
                          <button onClick={() => onSend(p.id)} className="p-2 bg-slate-50 text-slate-500 rounded-lg hover:text-emerald-600 border border-transparent hover:border-slate-200 transition-all">
                            <Send size={18} />
                          </button>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
  );
}